/* The slot-state chip (designs/products-pdp.md, Chip tokens): one of the four
   `.state` variants with its fixed words — `.state.evidence`, `.state.estimate`
   `est. {p}%`, `.state.missing` not recorded, `.state.unconfirmed`. Every
   place that shows a slot's state (Deliverables table, review sheet, paper)
   renders this so the words and the class never drift apart. */
import type { JSX } from "react";
import { stateText, type SlotState } from "./model";

const CHIP_CLASS: Record<SlotState, string> = {
  missing: "missing",
  estimated: "estimate",
  unconfirmed: "unconfirmed",
  evidence: "evidence",
};

export function StateChip({ state, percent }: { state: SlotState; percent?: number }): JSX.Element {
  return <span className={`state ${CHIP_CLASS[state]}`}>{stateText(state, percent)}</span>;
}
